import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import VehicleRequisitionApprovalForm from "../../forms/VehicleReq/VehicleRequisitionApprovalForm";
import {
  getPendingAndApprovedVehicleRequisitions,
  approveVehicleRequisitions,
  rejectVehicleRequisitions,
} from "../../../api/vehicleRequisitionApprovalApi";
import { getSignedAttachmentUrl } from "../../../api/attachApi";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function VehicleRequisitionApprovalPage({ history }) {
  const location = useLocation();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [vehicleRequisitions, setVehicleRequisitions] = useState([]);
  const [selectedVehicleRequisitions, setSelectedVehicleRequisitions] =
    useState([]);
  const [currentYear, setCurrentYear] = useState(
    location.state ? location.state.year : dayjs().year()
  );
  const [pagination, setPagination] = useState({
    current: 1,
    minIndex: 0,
    maxIndex: 100,
    pageSize: 100,
  });

  useEffect(getVehicleRequisitions, [currentYear]);

  function getVehicleRequisitions() {
    setIsLoading(true);
    getPendingAndApprovedVehicleRequisitions(currentYear)
      .then((value) => {
        // reset pagination
        resetPagination();

        setVehicleRequisitions(value ? value : []);
        setSelectedVehicleRequisitions([]);
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record"), error);
      });
  }

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  function onAddNewVehicleRequisition() {
    history("/home/vehiclerequisition/vehicletrans");
  }

  function onApproveVehicleRequisitions(selectedVehicleRequisitions) {
    setIsLoading(true);

    approveVehicleRequisitions(selectedVehicleRequisitions)
      .then(() => {
        getVehicleRequisitions();
        toast.success(t("general.record_approved_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_approve_record"), error);
      });
  }

  function onRejectVehicleRequisitions(
    selectedVehicleRequisitions,
    reason,
    isAllowAmend
  ) {
    setIsLoading(true);

    rejectVehicleRequisitions(selectedVehicleRequisitions, reason, isAllowAmend)
      .then(() => {
        getVehicleRequisitions();
        toast.success(t("general.record_rejected_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_reject_record"), error);
      });
  }

  function viewVehicleRequisition(vehicleRequisitionKey) {
    history("/home/vehiclerequisition/vehicletrans/" + vehicleRequisitionKey, {
      state: { fromApproval: true },
    });
  }

  function getValidAttachments(attachments) {
    return getSignedAttachmentUrl(attachments);
  }

  function showErrorMessage(message, error) {
    let errorMsg = error.response.data.error_description
      ? error.response.data.error_description
      : error.response.data.ExceptionMessage;

    toast.error(message + (errorMsg ? errorMsg : ""));
  }

  return (
    <VehicleRequisitionApprovalForm
      isLoading={isLoading}
      data={vehicleRequisitions}
      selectedItems={selectedVehicleRequisitions}
      onAdd={onAddNewVehicleRequisition}
      onView={viewVehicleRequisition}
      onApproved={onApproveVehicleRequisitions}
      onRejected={onRejectVehicleRequisitions}
      onItemSelected={setSelectedVehicleRequisitions}
      onAttachmentClicked={getValidAttachments}
      setCurrentYear={setCurrentYear}
      currentYear={currentYear}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
}

VehicleRequisitionApprovalPage.propTypes = {
  history: PropTypes.func.isRequired,
};
